module.exports = __webpack_public_path__ + "static/media/ic_show_track.2ccce0bd.svg";